import { render, staticRenderFns } from "./x-textarea.vue?vue&type=template&id=99a22ff0&"
import script from "./x-textarea.vue?vue&type=script&lang=js&"
export * from "./x-textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/welearn-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('99a22ff0', component.options)
    } else {
      api.reload('99a22ff0', component.options)
    }
    module.hot.accept("./x-textarea.vue?vue&type=template&id=99a22ff0&", function () {
      api.rerender('99a22ff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-textarea.vue"
export default component.exports